import api from '../config/axiosConfig';

export const ProvinciaService = {
  fetchProvinciasPorDepartamento: async (token, departmentId) => {
    try {
      const response = await api.get(`/locations/provinces/${departmentId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        console.error("La API no devolvió success=true");
        return [];
      }
    } catch (error) {
      console.error("Error en ProvinciaService.fetchProvinciasPorDepartamento:", error);
      throw error;
    }
  },
};
